// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Wl9W","content":"styles_content__3GaKM"};